const color = {
  basic100: '#1A1B1E',
  basic150: '#1F2024',
  basic200: '#2F3137',
  basic300: '#34363C',
  basic350: '#3F424A',
  basic400: '#525660',
  basic450: '#6A6F7C',
  basic500: '#757B8A',
  basic600: '#969BA6',
  basic700: '#B7BAC2',
  basic800: '#E3E5E8',
  basic900: '#F1F2F3',
  white: '#FFFFFF',

  primary100: '#3D6AFF',
  primary200: '#7091FF',
  primaryHover: '#1A4FFF',
  primaryPressed: '#003BFF',

  stateError: '#A24235',
  stateSafe: '#239C64',

  dashboardBlue: '#0E63FE',
  dashboardPink: '#9840CC',

  bg100: '#1A1B1E',
  bg150: '#1F2024',
  bg200: '#2F3137',
  bg300: '#34363C',
  bgModal: '#0C0C0EB2',
}

const theme = {
  color,
}

export default theme;